import React from 'react';
import { PropTypes } from 'prop-types';
import SearchEventsUpcoming from '../../searches/SearchEventsUpcoming/index.js';
import LoadingArea from '@molecules/LoadingArea';
import { BodyLarge } from '@styled';
import useMemberFull from '@hooks/useMemberFull';

const MemberProfileRegisteredEvents = ({ graphID }) => {
    const { data } = useMemberFull(graphID);

    if (!data) return <LoadingArea />;

    if (data.events.length === 0) {
        return <BodyLarge>{data.firstName} has no upcoming events.</BodyLarge>;
    }

    return (
        <div className="fade-in-fast">
            <BodyLarge className="mb-2rem">{data.firstName}'s upcoming events</BodyLarge>
            <SearchEventsUpcoming memberGraphID={graphID} />
        </div>
    );
};

MemberProfileRegisteredEvents.propTypes = {
    graphID: PropTypes.string,
};

export default MemberProfileRegisteredEvents;
